/**
 * @author rmh
 * 模块说明：采购分仓
 */
import { Service } from '@/tools'

export class replacementService<T extends TProcure.replacement> extends Service {
  constructor(path: string) {
    super()
    this.setPathPrefix(path)
  }

  private post2<P extends TCommon.ApiVersion = 'v1'>(url: `${P}/${keyof TProcure.replacement}`, data?: TCommon.Json, toast?: string) {
    return this.post(url, data, toast)
  }

  /**
   * 模块说明：多发品种供应商发货清单源单据实收数为0商品分页查询
   *  /api/procure/variety/replacement/task/v1/collectMoreProductPage
   */
  collectMoreProductPage = <K extends T['ApiCollectMoreProductPage']>(data: K['req']): Promise<K['res']> => {
    return this.post2('v1/ApiCollectMoreProductPage', data)
  }

  /**
   * 模块说明：任务重试（只执行当前采购单或供应商发货通知单商品信息替换
   *  /api/procure/variety/replacement/task/v1/taskRetry
   */
  taskRetry = <K extends T['ApiTaskRetry']>(data: K['req']): Promise<K['res']> => {
    return this.post2('v1/ApiTaskRetry', data, '操作成功')
  }

  /**
   * 模块说明：品种替换单据查询
   *  api/procure/variety/replacement/task/v1/queryVarietyReplacementOrder
   */
  queryVarietyReplacementOrder = <K extends T['ApiQueryVarietyReplacementOrder']>(data: K['req']): Promise<K['res']> => {
    return this.post2('v1/ApiQueryVarietyReplacementOrder', data)
  }

  /**
   * 模块说明：开始替换
   *  api/procure/variety/replacement/task/v1/startReplacement
   */
  startReplacement = <K extends T['ApiStartReplacement']>(data: K['req']): Promise<K['res']> => {
    return this.post2('v1/ApiStartReplacement', data)
  }

  /**
   * 模块说明：品种替换执结果单据分页查询
   *  api/procure/variety/replacement/task/v1/orderPage
   */
  orderPage = <K extends T['ApiOrderPage']>(data: K['req']): Promise<K['res']> => {
    return this.post2('v1/ApiOrderPage', data)
  }

  /**
   * 模块说明：单据重试(只执行当前单据)
   *  /api/procure/variety/replacement/task/v1/orderRetry
   */
  orderRetry = <K extends T['ApiOrderRetry']>(data: K['req']): Promise<K['res']> => {
    return this.post2('v1/ApiOrderRetry', data, '操作成功')
  }

  /**
   * 模块说明：品种替换详情
   * /api/procure/variety/replacement/task/v1/detail
   */
  detail = <K extends T['ApiDetail']>(data: K['req']): Promise<K['res']> => {
    return this.post2('v1/ApiDetail', data)
  }
}
